import React, { useEffect, useState } from 'react'
import styles from './LatestActionInfo.module.scss'
import { BlockHeader } from 'components/UI/BlockHeader/BlockHeader'
import { GoToLink } from 'components/UI/SuperButton/SuperButton'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import { localisationMaster } from 'Localisation/Localisation'
import { dateFormat } from 'helpers/date'
import Stores from 'Stores'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import { addZero } from '../../../../helpers/math'
import { Link } from 'react-router-dom'
import useLocalization from '../../../../hooks/useLocalization'

function dateFormatForLatestAction(oDate = new Date(), format = 'dd.mm.YYYY') {
  try {
    if (typeof oDate === 'string' || typeof oDate === 'number') {
      oDate = new Date(oDate)
      oDate = new Date(
        Date.UTC(
          oDate.getUTCFullYear(),
          oDate.getUTCMonth(),
          oDate.getUTCDate(),
          oDate.getUTCHours(),
          oDate.getUTCMinutes(),
          oDate.getUTCSeconds(),
        ),
      )
    }

    // Массив месяцев для локализации
    const months = [
      localisationMaster('months_1', 'months'),
      localisationMaster('months_2', 'months'),
      localisationMaster('months_3', 'months'),
      localisationMaster('months_4', 'months'),
      localisationMaster('months_5', 'months'),
      localisationMaster('months_6', 'months'),
      localisationMaster('months_7', 'months'),
      localisationMaster('months_8', 'months'),
      localisationMaster('months_9', 'months'),
      localisationMaster('months_10', 'months'),
      localisationMaster('months_11', 'months'),
      localisationMaster('months_12', 'months'),
    ]

    // Форматирование даты
    format = format
      .replace('dd', addZero(oDate.getUTCDate()))
      .replace('d', oDate.getUTCDate())
      .replace('mm', addZero(oDate.getUTCMonth() + 1))
      .replace('MMMM', months[oDate.getUTCMonth()].toLowerCase())
      .replace('MMM', months[oDate.getUTCMonth()])
      .replace('YYYY', oDate.getUTCFullYear())
      .replace('YY', String(oDate.getUTCFullYear()).slice(2))
      .replace('hh', addZero(oDate.getUTCHours()))
      .replace('ii', addZero(oDate.getUTCMinutes()))
      .replace('ss', addZero(oDate.getUTCSeconds()))
    return format
  } catch (e) {
    return 'Invalid date'
  }
}

const getOperation = (op) => {
  let rows = []

  const cud = () =>
    Object.keys(op.old).length === 0
      ? 1
      : Object.keys(op.new).length === 0
        ? -1
        : 0

  const schedule = (sch) => {
    const rows = []

    sch.start_at &&
      sch.finish_at &&
      rows.push(`
            ${sch.start_at.slice(0, 5)} - ${sch.finish_at.slice(0, 5)} 
            ${
              sch.hours_per_day
                ? ` (${+sch.hours_per_day} ${
                    +sch.hour_type_id === 1
                      ? localisationMaster('ac_h', 'groups/group')
                      : localisationMaster('astr_h', 'groups/group')
                  })`
                : ''
            }`)

    sch.date_from &&
      sch.date_until &&
      rows.push(
        `${dateFormat(new Date(sch.date_from), 'dd MMM YYYY')} ${localisationMaster('yr', 'groups/group')} - ${dateFormat(new Date(sch.date_until), 'dd MMM YYYY')} ${localisationMaster('yr', 'groups/group')}`,
      )

    sch.hours_total &&
      rows.push(
        `${localisationMaster('text_1', 'groups/group', 'group_log')}: ${+sch.hours_total} ${+sch.hour_type_id === 1 ? localisationMaster('ac_h', 'groups/group') : localisationMaster('astr_h', 'groups/group')}`,
      )

    Array.isArray(sch.teachers_name) &&
      rows.push(
        `${localisationMaster('text_2', 'groups/group', 'group_log')}: ${Stores.transliterate(`${sch.teachers_name.join(', ')}`)}`,
      )

    sch.classroom_name &&
      rows.push(
        `${localisationMaster('text_3', 'groups/group', 'group_log')}: ${sch.classroom_name}`,
      )

    return rows
  }

  try {
    switch (op.operation_type) {
      // Расписания
      case 'schedule':
        rows.push(
          `${
            cud() === 1
              ? localisationMaster('add', 'groups/group', 'group_log')
              : cud() === -1
                ? localisationMaster('removed', 'groups/group', 'group_log')
                : localisationMaster('changed', 'groups/group', 'group_log')
          } ${localisationMaster('text_5', 'groups/group', 'group_log')}`,
        )
        break
      case 'workshop':
        rows.push(
          `${
            cud() === 1
              ? localisationMaster('add', 'groups/group', 'group_log')
              : cud() === -1
                ? localisationMaster('removed', 'groups/group', 'group_log')
                : localisationMaster('changed', 'groups/group', 'group_log')
          } ${localisationMaster('text_5', 'groups/group', 'group_log')}`,
        )
        if (cud() === 1) {
          rows = rows.concat(schedule(op.new))
        } else if (cud() === 0) {
          rows.push(
            `${localisationMaster('text_6', 'groups/group', 'group_log')}:`,
          )
        } else {
          rows = rows.concat(schedule(op.old))
        }
        break
      // Группа
      case 'name':
      case 'location':
      case 'company':
      case 'number':
      case 'status':
      case 'discipline':
      case 'type':
      case 'size':
      case 'doc_type':
      case 'doc_type_description':
      case 'course_level':
      case 'skill_level':
      case 'default_price':
        const whats = {
          name: localisationMaster('text_19', 'groups/group', 'group_log'),
          location: localisationMaster('text_20', 'groups/group', 'group_log'),
          company: localisationMaster('text_21', 'groups/group', 'group_log'),
          number: localisationMaster('text_22', 'groups/group', 'group_log'),
          status: localisationMaster('text_23', 'groups/group', 'group_log'),
          discipline: localisationMaster(
            'text_24',
            'groups/group',
            'group_log',
          ),
          type: localisationMaster('text_25', 'groups/group', 'group_log'),
          size: localisationMaster('text_26', 'groups/group', 'group_log'),
          doc_type: localisationMaster('text_27', 'groups/group', 'group_log'),
          course_level: localisationMaster(
            'text_28',
            'groups/group',
            'group_log',
          ),
          skill_level: localisationMaster(
            'text_29',
            'groups/group',
            'group_log',
          ),
          comment: localisationMaster('text_30', 'groups/group', 'group_log'),
          default_price: localisationMaster(
            'text_31',
            'groups/group',
            'group_log',
          ),
        }

        if (cud() === 1) {
          rows.push(
            `${localisationMaster('text_18', 'groups/group', 'group_log')}:`,
          )
        } else {
          rows.push(
            `${localisationMaster('text_17', 'groups/group', 'group_log')}: ${whats[op.operation_type]}`,
          )
        }
        break
      // Комментарий к группе (м.б. с тегами)
      case 'comment':
        const what = localisationMaster('text_30', 'groups/group', 'group_log')

        if (cud() === 1) {
          rows.push(
            `${localisationMaster('text_18', 'groups/group', 'group_log')}:`,
          )
        } else {
          rows.push(
            `${localisationMaster('text_17', 'groups/group', 'group_log')}: ${what}`,
          )
        }
        break
      // Студенты
      case 'new_client':
        rows.push(
          `${localisationMaster('add_2', 'groups/group', 'group_log')}  ${Stores.transliterate(`${op.new.client_name}`)}`,
        )
        break
      case 'student_default_price':
        rows.push(
          `${cud() === 1 ? localisationMaster('add_1', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_1', 'groups/group', 'group_log') : localisationMaster('changed_1', 'groups/group', 'group_log')} ${localisationMaster('text_8', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.student_name || op.old.student_name}`)}`,
        )
        break
      case 'student_discounts':
        rows.push(
          `${cud() === 1 ? localisationMaster('add_1', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_1', 'groups/group', 'group_log') : localisationMaster('changed_1', 'groups/group', 'group_log')} ${localisationMaster('text_9', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.student_name || op.old.student_name}`)}`,
        )
        break
      case 'student_surcharges':
        rows.push(
          `${cud() === 1 ? localisationMaster('add_1', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_1', 'groups/group', 'group_log') : localisationMaster('changed_1', 'groups/group', 'group_log')} ${localisationMaster('text_9', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.student_name || op.old.student_name}`)}`,
        )
        break
      case 'client_status':
        rows.push(
          `${localisationMaster('text_11', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.client_name}`)}`,
        )
        break
      case 'client_study_dates':
        rows.push(
          `${localisationMaster('text_12', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.client_name}`)}`,
        )
        break
      // Статусы преподавателей
      case 'teacher_status':
        rows.push(
          `${cud() === 1 ? localisationMaster('set', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_2', 'groups/group', 'group_log') : localisationMaster('changed_2', 'groups/group', 'group_log')} ${localisationMaster('text_15', 'groups/group', 'group_log')}: ${dateFormat(new Date(op.new.date), 'dd MMM YYYY')} ${localisationMaster('yr', 'groups/group')}`,
        )
        break
      // Статусы студентов
      case 'student_status':
        rows.push(
          `${cud() === 1 ? localisationMaster('set', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_2', 'groups/group', 'group_log') : localisationMaster('changed_2', 'groups/group', 'group_log')} ${localisationMaster('text_16', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.student_name}`)}, ${dateFormat(new Date(op.new.date), 'dd MMM YYYY')} ${localisationMaster('yr', 'groups/group')}`,
        )
        break
      default:
        break
      case 'workshop_teacher_replace':
        rows.push(
          `${localisationMaster('changed', 'groups/group', 'group_log')} ${localisationMaster('text_5', 'groups/group', 'group_log')}`,
        )
        if (op.new && op.new.group_name) {
          rows.push(
            `${localisationMaster('text_7', 'groups/group', 'group_log')}: ${Stores.transliterate(op.new.group_name)}`,
          )
        }
        break
      case 'workshop_transfer':
        rows.push(
          `${localisationMaster('changed', 'groups/group', 'group_log')} ${localisationMaster('text_5', 'groups/group', 'group_log')}`,
        )
        if (op.new && op.new.group_name) {
          rows.push(
            `${localisationMaster('text_7', 'groups/group', 'group_log')}: ${Stores.transliterate(op.new.group_name)}`,
          )
        }
        break
    }
  } catch (e) {
    rows.push(e.toString())
  }

  return rows
}
const LatestActionInfo = ({ userId }) => {
  const [logData, setLogData] = useState([])
  const [logsToShow, setLogsToShow] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [dateStart, setDateStart] = useState(null)
  const [dateEnd, setDateEnd] = useState(null)

  const apiConf = {
    method: 'get',
    link: `logs/action_history`,
    params: {
      limit: 5,
      offset: 0,
    },
  }
  const { translate } = useLocalization({
    section: 'profile',
    subsection: 'latest_actions',
    dict: {
      title: 'Latest actions',
    },
  })

  const getStats = async () => {
    try {
      setIsLoading(true)
      const res = await superAxiosRequest(apiConf)
      setLogData(res?.data?.result)
    } catch (error) {
      console.log('error', error)
    } finally {
      setIsLoading(false)
    }
  }
  useEffect(() => {
    getStats()
  }, [userId])

  useEffect(() => {
    if (dateStart && dateEnd) {
      const startOfDayUTC = Date.UTC(
        dateStart.getFullYear(),
        dateStart.getMonth(),
        dateStart.getDate(),
        0,
        0,
        0,
      )
      const endOfDayUTC = Date.UTC(
        dateEnd.getFullYear(),
        dateEnd.getMonth(),
        dateEnd.getDate(),
        23,
        59,
        59,
      )

      setLogsToShow(
        logData.filter((log) => {
          const logDateUTC = new Date(log.updated_at).getTime()

          return logDateUTC >= startOfDayUTC && logDateUTC <= endOfDayUTC
        }),
      )
    } else {
      setLogsToShow(logData)
    }
  }, [dateStart, dateEnd, logData])

  return (
    <div className={styles.main}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <BlockHeader title={translate?.title}>
            <GoToLink target={'_blank'} to={'/latest'} />
          </BlockHeader>
          <div>
            {logsToShow.map((log, index) => (
              <div
                key={index}
                className={`${styles.logItem}  ${index % 2 === 0 ? styles.logContentColored : ''}   `}
              >
                <div className={styles.logContent}>
                  <div>
                    {getOperation(log).map((r, idx) =>
                      log.operation_type === 'comment' ? (
                        <div
                          className={styles.logTopic}
                          key={idx}
                          dangerouslySetInnerHTML={{ __html: r }}
                        />
                      ) : (
                        <div className={styles.logUserRole} key={idx}>
                          {r}
                        </div>
                      ),
                    )}
                    <div
                      className={`${styles.groupName} ${styles.hiddenContent}`}
                    >
                      <Link
                        target='_blank'
                        to={`/groups/group/${log.group_data.id}`}
                      >
                        <span>{log.group_data.number}</span>
                        <span> {' - '} </span>
                        <span>{log.group_data.name}</span>
                      </Link>
                    </div>
                  </div>
                  <div
                    className={`${styles.groupName} ${styles.hiddenGroupContent}`}
                  >
                    <Link
                      target='_blank'
                      to={`/groups/group/${log.group_data.id}`}
                    >
                      <span>{log.group_data.number}</span>
                      <span> {' - '} </span>
                      <span>{log.group_data.name}</span>
                    </Link>
                  </div>
                  <div className={styles.timeAndDate}>
                    <div className={styles.logTime}>
                      {dateFormatForLatestAction(log.updated_at, 'hh:ii')}
                    </div>
                    <div className={styles.logSecondDate}>
                      {dateFormatForLatestAction(log.updated_at, 'd MMMM YYYY')}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default observer(LatestActionInfo)
